
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { motion } from 'framer-motion';
import cn from 'classnames';

import { deletePushMessage } from '../../model/slice';
import { ANIMATION_PROPS, PushTypes } from '../../model/constants';
import { PushMessage as PushMessageProps } from '@/features/common/push/model/messages';

import cls from '../assets/styles.module.pcss';
import CloseIcon from '../assets/close.svg?react';

interface Props {
  message: PushMessageProps
  id: string
}

export function PushMessage({ message, id }: Props) {
  const [timeout, setTimeoutFunc] = useState<number>();
  const dispatch = useDispatch();

  function deleteMessage() {
    dispatch(deletePushMessage(id));
    if (timeout) clearTimeout(timeout);
  }

  useEffect(() => {
    if (message.timer) {
      setTimeoutFunc(setTimeout(deleteMessage, message.timer));
    }
  }, []);

  return (
    <motion.div
      className={cn(cls.PushMessage, {
        [cls.PushMessageInfo]: message.type === PushTypes.INFO,
        [cls.PushMessageError]: message.type === PushTypes.ERROR,
        [cls.PushMessageSuccess]: message.type === PushTypes.SUCCESS,
      })}
      {...ANIMATION_PROPS}
    >
      <div className={cls.PushMessageHeader}>
        <div className={cls.PushMessageTitle}>
          {message.title}
        </div>

        <div className={cls.PushMessageClose} onClick={deleteMessage}>
          <CloseIcon />
        </div>
      </div>
      <div className={cls.PushMessageText}>
        {message.text}
      </div>
    </motion.div>
  );
}
